
import axios from "axios";

export default async function crmEnquiry(body) {
  try {
    await axios.post(
      "https://kalyani-api.yocoya.in/api/EscalatedReport/CreateCarLeadDetails/",
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          ApiKey: "YI0PzZIXnVNzkABA+/n/J74/r3I3C7RfYEFcGF9Ayo8="
        }
      }
    );
  } catch (error) {
    console.error('Error:', error);
  }
}